const subtleHeading = "SubmenuList-module_subtleHeading_B1Vmy62f";
const strongHeading = "SubmenuList-module_strongHeading_QHIXyD9N";
const list = "SubmenuList-module_list_YEbOYcq-";
const link = "SubmenuList-module_link_xefbaqa7";
const icon = "SubmenuList-module_icon_1h4ccAAD";
const listItem = "SubmenuList-module_listItem_KN4VbC16";
const label = "SubmenuList-module_label_J8sNAfc3";
const description = "SubmenuList-module_description_v--G85zn";
const styles = {
  subtleHeading,
  strongHeading,
  list,
  link,
  icon,
  listItem,
  label,
  description
};
export {
  styles as default,
  description,
  icon,
  label,
  link,
  list,
  listItem,
  strongHeading,
  subtleHeading
};
